import http from '../http'

export default {
  // 获取用户信息
  getMyAccountInfo(data: object, option: object = {}) {
    return http.get('/profile', data, option);
  },
  // 获取用户等级信息
  getUserLevelInfo() {
    return http.get('/user/level');
  }
}
